export default {
  slug: "intellij-idea",
  code: "IJ",
  label: "IntelliJ IDEA",
  isIDE: true,
  krakenDir: "IntelliJ IDEA",
  thumbnailColor: "#FDB60D",
  logoFamily: "ide",
  // The code highlight of the Demo Video banners (Figma "YouTube", "Code
  // highlight color" of the product section).
  codeHighlightColor: "#087CFA",
};
